// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocationProfile_location-profile__m\\+C65 {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe {
  width: 100%;
  max-width: 700px;
}
@media screen and (min-width: 1600px) {
  .LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe {
    max-width: 900px;
  }
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 input,
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 textarea {
  color: inherit;
  font: inherit;
  border-radius: 5px;
  border: 1px solid #aaa;
  padding: 5px 15px;
  box-shadow: 0 0 0 0 var(--accent-color-03-opacity);
  outline: none;
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 input:focus,
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 textarea:focus {
  box-shadow: 0 0 0 4px var(--accent-color-03-opacity);
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 .LocationProfile_main-heading__15oWz {
  margin-top: 30px;
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 .LocationProfile_main-heading__15oWz input {
  width: calc(100% - 50px);
  margin-right: 7px;
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 .LocationProfile_main-heading__15oWz sup {
  cursor: pointer;
  fill: hsl(207, 5%, 35%);
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 .LocationProfile_main-heading__15oWz sup:hover {
  fill: hsl(207, 5%, 30%);
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 .LocationProfile_main-heading__15oWz sup:active {
  fill: hsl(207, 5%, 25%);
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 .LocationProfile_description__H-0WX {
  white-space: pre-line;
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 .LocationProfile_description__H-0WX textarea {
  padding: 15px;
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_main-text-details__WHVZ9 .LocationProfile_email-and-number-input__thzym input {
  margin-right: 10px;
}
.LocationProfile_location-profile__m\\+C65 .LocationProfile_container__jYtfe .LocationProfile_add-button-container__d9n2h {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/Pages/LocationProfile/LocationProfile.module.scss"],"names":[],"mappings":"AAAA;EACG,YAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AACH;AACG;EACG,WAAA;EACA,gBAAA;AACN;AACM;EAJH;IAKM,gBAAA;EAEP;AACF;AAES;;EAEG,cAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kDAAA;EACA,aAAA;AAAZ;AAEY;;EACG,oDAAA;AACf;AAGS;EACG,gBAAA;AADZ;AAGY;EACG,wBAAA;EACA,iBAAA;AADf;AAIY;EACG,eAAA;EACA,uBAAA;AAFf;AAKY;EACG,uBAAA;AAHf;AAMY;EACG,uBAAA;AAJf;AAQS;EAKG,qBAAA;AAVZ;AAMY;EACG,aAAA;AAJf;AAWY;EACG,kBAAA;AATf;AAcM;EACG,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAZT","sourcesContent":[".location-profile {\n   height: 100%;\n   width: 100%;\n   overflow-y: scroll;\n   padding: 20px;\n   display: flex;\n   flex-direction: column;\n   align-items: center;\n   position: relative;\n\n   .container {\n      width: 100%;\n      max-width: 700px;\n\n      @media screen and (min-width: 1600px) {\n         max-width: 900px;\n      }\n\n      .main-text-details {\n\n         input,\n         textarea {\n            color: inherit;\n            font: inherit;\n            border-radius: 5px;\n            border: 1px solid #aaa;\n            padding: 5px 15px;\n            box-shadow: 0 0 0 0 var(--accent-color-03-opacity);\n            outline: none;\n\n            &:focus {\n               box-shadow: 0 0 0 4px var(--accent-color-03-opacity);\n            }\n         }\n\n         .main-heading {\n            margin-top: 30px;\n\n            input {\n               width: calc(100% - 50px);\n               margin-right: 7px;\n            }\n\n            sup {\n               cursor: pointer;\n               fill: hsl(207, 5%, 35%)\n            }\n\n            sup:hover {\n               fill: hsl(207, 5%, 30%)\n            }\n\n            sup:active {\n               fill: hsl(207, 5%, 25%)\n            }\n         }\n\n         .description {\n            textarea {\n               padding: 15px;\n            }\n\n            white-space: pre-line;\n         }\n\n         .email-and-number-input {\n            input {\n               margin-right: 10px;\n            }\n         }\n      }\n\n      .add-button-container {\n         display: flex;\n         flex-direction: row;\n         align-items: center;\n         justify-content: center;\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"location-profile": `LocationProfile_location-profile__m+C65`,
	"container": `LocationProfile_container__jYtfe`,
	"main-text-details": `LocationProfile_main-text-details__WHVZ9`,
	"main-heading": `LocationProfile_main-heading__15oWz`,
	"description": `LocationProfile_description__H-0WX`,
	"email-and-number-input": `LocationProfile_email-and-number-input__thzym`,
	"add-button-container": `LocationProfile_add-button-container__d9n2h`
};
export default ___CSS_LOADER_EXPORT___;
